import { render, staticRenderFns } from "./QuoteDetail.vue?vue&type=template&id=40e34938&"
import script from "./QuoteDetail.vue?vue&type=script&lang=js&"
export * from "./QuoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuoteDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuoteDetail.vue"
export default component.exports